// extracted by css-extract-rspack-plugin
export default {"content":"content-L24yRh"};